import InputFormik from '../../../../../../../../common/components/form/InputFormik';
import ComboBoxFormik from '../../../../../../../../common/components/form/ComboBoxFormik';
import { formatCurrency, maskCurrency } from '../../../../../../../../common/helpers/mask.helpers';
import { formatDateAndTime } from '@/common/helpers/date.helpers';

export function CancellationDetails({
  finePlanValue,
  cancellationReasonOptions,
  repossessionDate
}) {
  return (
    <section className='space-y-2'>
      <div className="grid grid-cols-2 gap-4">
        <div className="">
          <InputFormik
            required={true}
            label="Digite o valor da diária para calcular a multa"
            name="dailyValue"
            mask={formatCurrency}
          />
        </div>

        <div className="">
          <label className="font-semibold text-sm">O valor da multa contratual é:</label>
          <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
            {maskCurrency(finePlanValue)}
          </p>
        </div>
        <div className="">
          <label className="font-semibold text-sm">A data do recolhimento:</label>
          <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
            {repossessionDate ? formatDateAndTime(new Date(repossessionDate)) : '-'}
          </p>
        </div>

        <ComboBoxFormik
          name="reason"
          label="Motivo do cancelamento"
          options={cancellationReasonOptions}
          required={true}
        />
      </div>
    </section>
  );
}
